import React, {ReactElement} from 'react';
import {EventKind} from 'services/analytics';
import {toReadable} from 'shared/utils/number';
import {useSavedMoney} from 'ui/utils/core';
import {RegisterAfterMount} from 'ui/adapters/Analytics';
import {Shout, Text} from 'components/Text';
import {Section} from 'components/Section';

export const Success = (): ReactElement => {
  const saved = useSavedMoney();

  return (
    <RegisterAfterMount event={EventKind.UserSavedMoney}>
      <Section data-test='success-message'>
        <Shout>Успех</Shout>
        <Text>Поздравляем!</Text>
        <Text data-test='saved'>Вы сэкономили {toReadable(saved)}</Text>
      </Section>
    </RegisterAfterMount>
  );
};
